import React from 'react';
import { connect } from 'react-redux';
import clever from '../../assets/images/clever.ico';
import classlink from '../../assets/images/classlink.png';
import config from '../../common/config';
import { resolveSyncedProvider, syncedProviderName } from '../../common/utils';

// Provider-specific "roster-synced" badge shown next to synced accounts/learners.
// `provider` is the backend `sso_synced_provider` field ('clever' | 'classlink'
// | null/undefined); when it's missing, pass `synced` so the badge can fall back
// to the Org's default SSO provider instead of dropping the icon. Renders
// nothing when the object isn't roster-synced (or when neither the object nor
// the Org identifies a provider).
const PROVIDER_META = {
  clever: { src: clever },
  classlink: { src: classlink },
};

const mapStateToProps = (state, ownProps?) => ({
  // A superadmin's own org settings say nothing about the org whose objects
  // they're looking at, so don't let them drive the fallback.
  orgDefaultSsoProvider:
    state.auth.user?.usertype === config.SUPERADMIN_USERTYPE
      ? null
      : state.status.userOrgSettings?.default_sso_provider ?? null,
});

const SsoSyncedBadge = ({ provider, synced, orgDefaultSsoProvider, style }) => {
  if (synced === false) return null;
  // Only fall back to the Org default for objects we know are synced — absent a
  // `synced` prop, the presence of `provider` is the only synced signal we have.
  const resolved = resolveSyncedProvider(
    provider,
    synced === true ? orgDefaultSsoProvider : null
  );
  const meta = PROVIDER_META[resolved];
  if (!meta) return null;
  return (
    <img
      style={{ width: '1rem', marginLeft: '0.25rem', ...style }}
      alt={resolved}
      title={`${syncedProviderName(resolved)}-synced`}
      src={meta.src}
    />
  );
};

export default connect(mapStateToProps)(SsoSyncedBadge);
